import { FileDelimitedOutlineIcon } from './FileDelimitedOutlineIcon';

/**
 * author: Terren
 * id 35CE4750-7CA9-4C9B-AB11-5C1F2A092C9C
 * name file-delimited-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-delimited-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileCsvOutlineIcon = FileDelimitedOutlineIcon;
export default FileCsvOutlineIcon